import { useMemo } from "react";
import { useIntl } from "react-intl";
import { Locale } from "../types";

type TranslationFunction = (translationKey: string, values?: any) => any;

type UseTranslationsReturnType = {
  translate: TranslationFunction;
  locale: Locale;
};

export const useTranslations = (): UseTranslationsReturnType => {
  const intl = useIntl();

  const translate: TranslationFunction = useMemo(
    () => (translationKey, values) =>
      intl.formatMessage({ id: translationKey }, values, { ignoreTag: true }),
    [intl]
  );

  return { translate, locale: intl.locale as Locale };
};

export const localeFromString = (value: string = "") =>
  isLocale(value) ? value : undefined;

export const isLocale = (value: string): value is Locale =>
  Object.keys(Locale).includes(value);
